import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const defaultRenderTypeSelect = (props, formControlProps = {}) => /*#__PURE__*/_jsx(FormControl, Object.assign({
  label: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "labels.subscriptionType"
  })
}, formControlProps, {
  children: /*#__PURE__*/_jsx(Select, Object.assign({
    placeholder: I18n.text('placeholders.subscriptionType'),
    "data-selenium-test": "gdpr-sub-type-select"
  }, props))
}));
export const defaultRenderGroupSelect = (props, formControlProps) => /*#__PURE__*/_jsx(FormControl, Object.assign({
  label: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "labels.preferenceGroup"
  }),
  help: /*#__PURE__*/_jsx(Link, {
    href: `/settings/${PortalIdParser.get()}/marketing/email/preferences-center`,
    external: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "labels.openPreferenceGroupSettings"
    })
  }),
  tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "labels.preferenceGroupHelp"
  })
}, formControlProps, {
  children: /*#__PURE__*/_jsx(Select, Object.assign({
    placeholder: I18n.text('placeholders.preferenceGroup')
  }, props))
}));